import createCache from './createCache';

const defaultCache = createCache();

export default defaultCache;
